import React, { useEffect, useState, Fragment, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssignVehicleGroupsModal } from 'components/Modals';

import {
  Box,
  List,
  Divider,
  ListItem,
  Typography,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';

import { useStyles, listTextStyles, listItemsStyles } from './VehicleGroups.styled';

import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { UserContext } from 'context';
import Paginator from 'components/Paginator';
import { usersActions } from 'state/modules/users';
import DeleteIcon from '@material-ui/icons/Delete';
import { VehicleGroupsLabel } from 'components/VehiclesGroups';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';

const VehicleGroups = ({ id, editable = true, type = 'DIRECT' }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const listItemsClasses = listItemsStyles();
  const { orgType } = useContext(UserContext);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    limit: 3,
    user_id: id,
    access_type: type,
  });

  const { vehicleGroups, loading, pagination } = useSelector((state) => ({
    vehicleGroups: state.vehiclesGroups[type],
    loading: state.vehiclesGroups[`${type}Loading`],
    pagination: state.vehiclesGroups[`${type}Pagination`],
  }));
  const { fetchedAddUserVehicleGroupSuccess, fetchedDeleteUserVehicleGroupSuccess } = useSelector(
    (state) => state.users
  );

  const isOwner = orgType === 'msOwnerOrg';

  // Fetch VG on load
  useEffect(() => {
    dispatch(VehiclesGroupsActions.fetchVehicleGroups(params, type));
  }, []);

  // Fetch VG on update
  useEffect(() => {
    if (fetchedDeleteUserVehicleGroupSuccess || fetchedAddUserVehicleGroupSuccess) {
      dispatch(VehiclesGroupsActions.fetchVehicleGroups(params, type));
    }
  }, [id, fetchedAddUserVehicleGroupSuccess, fetchedDeleteUserVehicleGroupSuccess]);

  const handleChangePage = (event, newPage) => {
    const newParams = { ...params, page: newPage + 1 };
    setParams(newParams);
    dispatch(VehiclesGroupsActions.fetchVehicleGroups(newParams, type));
  };

  /**
   * Open assign service groups modal
   */
  const handleAssignVehicleGroup = () => {
    setOpen((prevState) => !prevState);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('users.add_vehicle_group', {
        type: VehicleGroupsLabel()?.toLowerCase(),
      }),
      onClick: handleAssignVehicleGroup,
    },
  ];

  const onDeleteClick = (item) => {
    const groupId = item.id;
    dispatch(usersActions.fetchDeleteUserVehicleGroups(id, groupId));
  };

  return (
    <Card
      menuItems={editable ? items : undefined}
      headerActionType="vertical"
      title={VehicleGroupsLabel({ plural: true, type })}
    >
      <Box className={classes.cardContentPadding}>
        {vehicleGroups?.length > 0 ? (
          <>
            <List className={classes.list}>
              {vehicleGroups?.map((val, index) => (
                <Fragment key={index}>
                  <ListItem>
                    <ListItemText classes={listClasses} primary={`${val.name}`} />
                    {editable ? (
                      <ListItemSecondaryAction classes={listItemsClasses}>
                        <Box fontSize={13}>
                          <IconButton onClick={() => onDeleteClick(val)}>
                            <DeleteIcon
                              style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }}
                            />
                          </IconButton>
                        </Box>
                      </ListItemSecondaryAction>
                    ) : null}
                  </ListItem>
                  <Divider className={classes.divider} />
                </Fragment>
              ))}
            </List>
            <Paginator
              component="div"
              limit={params.limit}
              pagination={pagination}
              onPageChange={handleChangePage}
            />
          </>
        ) : (
          <Typography color="textPrimary" style={{ lineHeight: 1 }}>
            <Box fontSize={14} component="span" lineHeight={1}>
              {isOwner
                ? i18n.t('users.no_fleet_groups_assigned')
                : i18n.t('users.no_vehicle_groups_assigned')}
            </Box>
          </Typography>
        )}
      </Box>
      {open && (
        <AssignVehicleGroupsModal id={id} open={open} handleClick={handleAssignVehicleGroup} />
      )}
    </Card>
  );
};

export { VehicleGroups };
